import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";
import { IKbCurrencyFilter } from "./kb-currency.filter";

@NgFilter({
    token: Token.FxConvertFilter,
    dependencies: [
        Token.$Filter,
        Token.KbService,
    ]
})
export class FxConvertFilter {
    constructor(
        $filter: ng.IFilterService,
        kbService: KbService
    ) {
        return ((value: number, currencyCode?: string, precision?: number) => {
            if (value == null) return "";
            let formattedValue = value.toString();
            if (currencyCode) {
                let convertedValue = kbService.fxConvert(value, currencyCode.toUpperCase());
                formattedValue = (($filter as any)("kbCurrency") as IKbCurrencyFilter)(convertedValue, currencyCode.toUpperCase(), precision);
            }
            return formattedValue;
        } ) as any;
    }
}
